/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { HideViewedFilterSchemaBy } from './hideViewedFilterSchemaBy';
import type { HideViewedFilterSchemaScope } from './hideViewedFilterSchemaScope';
import type { HideViewedFilterSchemaTimeRange } from './hideViewedFilterSchemaTimeRange';
import type { HideViewedFilterSchemaTimeUnit } from './hideViewedFilterSchemaTimeUnit';

export interface HideViewedFilterSchema {
  scope?: HideViewedFilterSchemaScope;
  by?: HideViewedFilterSchemaBy;
  time_range?: HideViewedFilterSchemaTimeRange;
  time_value?: number | null;
  time_unit?: HideViewedFilterSchemaTimeUnit;
}
